<template>
  <div class="tv_shop">
    <section class="main_content">
      <header class="main_tvHeading">
        <h2>{{$t('tvShop')}}</h2>
      </header>
      <div :class="{'hide':isLive}" v-if="!isLive">
        <LiveHost @openLiveShow="openLiveShow" :liveShow="liveShow" v-if="ShowCard" />
        <UpcomingLive :liveScheduleDTOs="liveScheduleDTOs" />
        <RecordedShowList />
      </div>
      <div class="live-show" v-else>
        <div class="live_video_block">
          <header>
            <span class="back" @click="exitLiveShow()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="18"
                height="16"
                viewBox="0 0 18 16"
              >
                <defs>
                  <path
                    id="a"
                    d="M7.993 14.119c.395.432.4 1.127.007 1.558a.936.936 0 0 1-1.418-.004L.297 8.779a1.173 1.173 0 0 1 0-1.56L6.582.326A.94.94 0 0 1 8 .32c.39.428.392 1.121-.007 1.559L3.414 6.902h13.584C17.55 6.902 18 7.39 18 8c0 .606-.452 1.097-1.002 1.097H3.414l4.58 5.023z"
                  />
                </defs>
                <use fill="#FFF" fill-rule="evenodd" xlink:href="#a" />
              </svg>
            </span>
            <span class="head-profile">
              <img :src="liveData.hostPicture" alt />
            </span>
            <span class="title">
              <span class="name">{{liveData.hostName}}</span>
              <span class="timing">
                <Timer
                  :timing="getLiveTime(liveData.liveEndTimeMilis)"
                  :GroupID="liveData.liveEndTimeMilis"
                />
              </span>
            </span>
            <span class="view">
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13">
                <g fill="#FFF" fill-rule="evenodd">
                  <path
                    d="M1.802 6.795c.402.623.878 1.247 1.421 1.826C4.743 10.243 6.478 11.2 8.4 11.2c1.922 0 3.657-.957 5.177-2.579A12.96 12.96 0 0 0 15.302 6.3a12.96 12.96 0 0 0-1.725-2.321C12.057 2.357 10.322 1.4 8.4 1.4c-1.922 0-3.657.957-5.177 2.579A12.959 12.959 0 0 0 1.498 6.3c.089.152.19.318.304.495zM.074 5.987c.098-.197.283-.525.552-.942.445-.69.97-1.378 1.576-2.024C3.962 1.143 6.034 0 8.4 0c2.366 0 4.437 1.143 6.198 3.021.605.646 1.13 1.335 1.576 2.024.269.417.454.745.552.942a.7.7 0 0 1 0 .626c-.098.197-.283.525-.552.942-.445.69-.97 1.378-1.576 2.024-1.76 1.878-3.832 3.021-6.198 3.021-2.366 0-4.437-1.143-6.198-3.021A14.345 14.345 0 0 1 .626 7.555C.357 7.138.172 6.81.074 6.613a.7.7 0 0 1 0-.626z"
                  />
                  <path
                    d="M8.4 9.1a2.8 2.8 0 1 1 0-5.6 2.8 2.8 0 0 1 0 5.6zm0-1.4a1.4 1.4 0 1 0 0-2.8 1.4 1.4 0 0 0 0 2.8z"
                  />
                </g>
              </svg>
              {{user_count}}
            </span>
          </header>
          <div class="post_video">
            <Videostream :connection="connection" :isLiveStatus="checkLive" />
            <div class="live-messsage" :class="{'cstm_height':this.extendCmnt}">
              <!-- <span class="live-call">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13">
                <path
                  fill="#FFF"
                  fill-rule="nonzero"
                  d="M2.071 8.041a12.288 12.288 0 0 0 3.47 3.863c.539.383 1.267.852 2.134 1.064.054.012.106.023.16.033.589.104 1.097-.016 1.556-.367a.052.052 0 0 0 .012-.01c.166-.141.348-.263.54-.392.13-.087.262-.178.39-.272.597-.436.714-1.103.296-1.7l-1.17-1.672c-.197-.293-.462-.476-.765-.53-.302-.052-.616.029-.908.233l-.996.697c-.07-.059-.143-.113-.212-.164a2.968 2.968 0 0 1-.235-.188C5.66 8.011 5.072 7.25 4.548 6.311c-.263-.487-.427-.886-.52-1.28.257-.162.502-.336.74-.506l.256-.182c.3-.21.49-.481.542-.781.053-.3-.03-.62-.242-.92l-.58-.829c-.069-.097-.132-.191-.198-.288a13.164 13.164 0 0 0-.396-.56c-.202-.281-.465-.457-.768-.51-.3-.053-.61.021-.906.217l-1.04.729A1.844 1.844 0 0 0 .69 2.468C.545 3.025.544 3.644.685 4.417c.216 1.195.656 2.348 1.386 3.624z"
                />
              </svg>

              <span>
                <a href="tel:011-41197300">011-41197300</a>
              </span>
              <span>कॉल करके यह सामान बुक करे</span>
              </span>-->
              <ul class="chat" id="content">
                <li v-for="(live_comment,index) in comments" :key="index">
                  <span class="block_icon" @click="block_user" v-if="isAdmin()">
                    <i class="material-icons">close</i>
                  </span>
                  <span class="user-img">
                    <img src="../assets/images/dummy.png" alt />
                  </span>
                  <span class="msg-text">
                    <span class="name">{{live_comment.name}}</span>
                    <span class="user-msg">{{live_comment.msg}}</span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="comment-part" v-if="nonAuthorizedUser">
              <input type="text" :placeholder="$t('writeComments')" v-model="comment" />
              <span @click="commentOnProduct('live')">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                  <path
                    fill="#FFF"
                    fill-rule="evenodd"
                    d="M0 12c.024-.429.095-.727.214-.895.12-.168.383-.34.79-.519L10.5 9 1.004 7.414C.59 7.19.327 7 .214 6.842.102 6.684.031 6.403 0 6V1.5A1.5 1.5 0 0 1 2.245.198V.2l15.297 8.109a.75.75 0 0 1 .087 1.339l-.086.043L2.246 17.8A1.5 1.5 0 0 1 0 16.5z"
                  />
                </svg>
              </span>
            </div>
            <div class="live-animation">
              <span class="animate heart-1">
                <img src="../assets/images/animateicons/purple_heart.png" alt />
              </span>
              <span class="animate heart-2">
                <img src="../assets/images/animateicons/red_heart.png" alt />
              </span>
              <span class="animate heart-3">
                <img src="../assets/images/animateicons/s_cyan_heart.png" alt />
              </span>
              <span class="animate heart-4">
                <img src="../assets/images/animateicons/s_pink_heart.png" alt />
              </span>
              <span class="animate heart-5">
                <img src="../assets/images/animateicons/s_yellow_heart.png" alt />
              </span>
              <span class="animate heart-6">
                <img src="../assets/images/animateicons/red_heart.png" alt />
              </span>
              <span class="animate heart-7">
                <img src="../assets/images/animateicons/sky_blue_heart.png" alt />
              </span>
              <span class="animate heart-8">
                <img src="../assets/images/animateicons/yellow_heart.png" alt />
              </span>
              <span class="animate heart-9">
                <img src="../assets/images/animateicons/red_heart.png" alt />
              </span>
              <span class="animate heart-10">
                <img src="../assets/images/animateicons/s_pink_heart.png" alt />
              </span>
            </div>
          </div>
          <!-- <ul class="product-show" :class="{'align-item' : liveData.itemLiveDTOs.length == 1}"> -->
          <ul class="product-show" :class="{'align-item' : liveData.itemLiveDTOs.length == 1}">
            <li
              v-for="(itemDTO,index) in liveData.itemLiveDTOs"
              :key="index"
              @click="goToProductDetail(itemDTO.saleReferenceID)"
            >
            <!-- <li
              v-for="(itemDTO,index) in liveData.itemLiveDTOs"
              :key="index"
              @click="goToProductDetail(itemDTO.saleReferenceID)"
            > -->
              <span class="product-img">
                <img :src="itemDTO.displayImage" alt />
              </span>
              <div class="product-content">
                <span class="p-name">{{itemDTO.productName}}</span>
                <span class="p-price">
                  <span>₹​{{itemDTO.sellingPrice}}</span>
                  <strike>₹​{{itemDTO.mrp}}</strike>
                </span>
                <span class="product-btn">{{$t('buyNow')}}</span>
              </div>
            </li>
          </ul>
          <LiveShopPopUp v-if="isLiveShopPopUp" :dataValue="allDetails" @closePopUp="isClosePopUp" />
        </div>
      </div>
    </section>
    <CustomToaster :dataValue="toasterData" v-if="isCommentLength" />
  </div>
</template>

<script>
import io from "socket.io-client";
import "../assets/css/tv-shopping.scss";
// import "../assets/css/product-detail.scss";
import Footer from "../components/Common/Footer";
import gaali from "../utils/gaali";
import LiveHost from "../components/TvShopSection/LiveHost";
import UpcomingLive from "../components/TvShopSection/UpcomingLive";
import RecordedShowList from "../components/TvShopSection/RecordedShowList";
import Videostream from "../components/TvShopSection/Videostream";
import { bus } from "../main";
import Timer from "../components/Common/TimeCount";
import CustomToaster from "../components/Common/CustomToaster";
import constant from "../utils/constant";
import LiveShopPopUp from "../components/TvShopSection/LiveShopPopUp";
export default {
  name: "TvShop",
  components: {
    Footer,
    LiveHost,
    UpcomingLive,
    RecordedShowList,
    Videostream,
    Timer,
    CustomToaster,
    LiveShopPopUp
  },
  data() {
    return {
      firebaseurl: "https://coupleapp-1154.firebaseio.com/game_users_answers",
      connection: {
        id: "mall91videochannel",
        key: "24d720d21ce748d499e936328229ac26",
        height: "100%",
        width: "100%"
      },
      socket: require("socket.io-client")(
        "https://dev1.money91.com/mall91socket"
      ),
      timeRemaining: "",
      nextTimeRemaining: "",
      user_count: 0,
      hidden: false,
      st: null,
      playing: false,
      selectedCatId: 0,
      agorahtml: "",
      productsVideos: [],
      pageIndex: 0,
      otherPageIndex: 0,
      type: "LIVE",
      isLive: false,
      salesRefId: "",
      XAuthId: "",
      interval: null,
      limit: 10,
      comments: [],
      name: "",
      comment: "",
      activePrdt: false,
      loading: false,
      liveData: {},
      nextLiveData: {},
      categories: [],
      liveScheduleDTOs: [],
      lastCommentTimestamp: 0,
      extendCmnt: false,
      cmnt_limit: 4,
      lastCommentTimestamp: 0,
      interval: null,
      nextInterval: null,
      liveShow: [],
      abusive: gaali,
      cntntLoad: false,
      selectRoomLang: "hi",
      ShowCard: true,
      timer: null,
      availableQuantityValue: "",
      nonAuthorizedUser: false,
      toasterData: {},
      isCommentLength: false,
      adminXAuthId: constant.adminXAuthIds,
      isLiveShopPopUp: false,
      testFlag: true,
      statusComplete: true,
      reloadData: false,
      langCheck: ['hi','en'].includes(this.$cookie.get('lang')),
      saleReferenceID: null,
      orderSourceType: null,
    };
  },
  created() {
    if (this.$refs.InfiniteLoading) {
      this.$refs.InfiniteLoading.stateChanger.reset();
    }
  },
  methods: {
    isClosePopUp(){
      this.isLiveShopPopUp = !this.isLiveShopPopUp
    },
    goToProductDetail(productSrId) {
      // const obj = {
      //   saleReferenceID: productSrId,
      //   referralUserId: this.$route.params.encodedId,
      //   orderSourceType: this.orderSourceType,
      //   cutPrice: null
      // };
      // this.$store
      //   .dispatch({
      //     type: "getProductDetail",
      //     payload: obj
      //   })
      //   .then(data => {
      //     this.loading = false;
      //     this.allDetails = data.data;
      //     this.isLiveShopPopUp = !this.isLiveShopPopUp
      //   });
      this.$router.push("/detail/" + productSrId + "?source=MALL91_LIVE");
    },
    isAdmin() {
      let xAuthId = this.$cookie.get("X-Auth-Id");
      for (let i = 0; i < this.adminXAuthId.length; i++) {
        if (xAuthId === this.adminXAuthId[i]) {
          return true;
        }
      }
    },
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (this.liveData.length > 0) {
        this.liveData[obj.index].status = false;
      }
    },
    downloadApp() {
      if (this.$cookie.get("X-Auth-Id") == null) {
        this.hidden = true;
        window.open("https://money91.app.link/twB3XD1OWQ");
      }
    },
    shareFunc(shareMessage, shareImage) {
      const obj = {
        message: shareMessage,
        imageUrl: shareImage
      };
      try {
        JSBridgePlugin.share(JSON.stringify(obj));
      } catch (err) {
        window.open("whatsapp://send?text=" + shareMessage);
      }
    },
    scrollToEnd() {
      var container = this.$el.querySelector("#content");
      container.scrollTop = container.scrollHeight;
    },   
    block_user() {
      this.socket.emit("block_user", {
        x_auth_id: this.$cookie.get("X-Auth-Id")
      });
    },
    commentOnProduct(deal_type) {
      var _this = this;
      if (this.comment && this.comment.trim().length > 0) {
        var _comment = this.comment.toLowerCase();
        for (var _ in this.abusive) {
          if (_comment.indexOf(this.abusive[_].toLowerCase()) > -1) {
            alert(
              "अनुचित व्यवहार या यौन और हिंसक सामग्री के परिणामस्वरूप आपके खाते को प्रतिबंधित किया जा सकता है और कानून प्रवर्तन अधिकारियों को सूचित किया जा सकता है।"
            );
            return;
          }
        }
        if (this.$cookie.get("X-Auth-Id") == null) {
          this.name = "Guest";
          this.socket.emit("new_msg_v_teen", {
            name: this.name,
            msg: this.comment,
            lang: this.selectRoomLang,
            x_auth_id: this.$cookie.get("X-Auth-Id")
          });
          this.comment = "";
        } else {
          if (this.$cookie.get("nickName")) {
            this.name = this.$cookie.get("nickName");
            this.socket.emit("new_msg_v_teen", {
              name: this.name,
              msg: this.comment,
              lang: this.selectRoomLang,
              x_auth_id: this.$cookie.get("X-Auth-Id")
            });
            this.comment = "";
          } else {
            let headers = {
              "x-auth-id": this.$cookie.get("X-Auth-Id")
            };
            this.$store
              .dispatch({
                type: "payBoardUser"
              })
              .then(data => {
                this.name = data.data.data.firstName;
                if ((this.name = this.name)) {
                  this.$cookie.set("nickName", this.name);
                }
                this.socket.emit("new_msg_v_teen", {
                  name: this.name,
                  msg: this.comment,
                  lang: this.selectRoomLang,
                  x_auth_id: this.$cookie.get("X-Auth-Id")
                });
                this.comment = "";
              })
              .catch(err => {
                let obj = {
                  status: "Failure",
                  timeoutMs: "5000"
                };
                bus.$emit("apiStatus", obj);
              });
          }
        }
      } else {
        this.isCommentLength = true;
        this.toasterData = {
          msg: "Please write comment first !",
          color: "red"
        };
      }
    },
    exitLiveShow() {
      var _this = this;
      this.socket.disconnect();
      this.socket.on("user_count", function(data) {
        _this.user_count = data;
      });
      this.isLive = false;
      if (this.interval != null) {
        clearInterval(this.interval);
      }
    },
    checkLive(status) {
      this.isLive = status;
    },
    scrollToBottom() {
      setTimeout(function() {
        var a = $(".chat");
        a.animate({
          scrollTop: a[0].scrollHeight
        });
      }, 100);
    },

    getLiveVideoComments() {
      var timestamp = new Date().getTime();
      this.$store
        .dispatch({
          type: "commentsBySaleAndTime",
          payload: this.liveData.saleReferenceID,
          Timestamp: this.lastCommentTimestamp
        })
        .then(data => {
          this.lastCommentTimestamp = timestamp;
          if (data.data.commentDTOs.length > 0) {
            this.comments = this.comments.concat(data.data.commentDTOs);

            this.scrollToBottom();
          }
        })
        .catch(err => {
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },

    setTimeText(liveData, fleg) {
      var text = "";
      var startDate = new Date(Number(liveData.liveStartTimeMilis));
      var endDate = new Date(Number(liveData.liveEndTimeMilis));

      var now = new Date().getTime();
      var distance = startDate - now;
      // Time calculations for days, hoconsoleurs, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (days != 0) {
        text = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
      } else {
        text = hours + "h " + minutes + "m " + seconds + "s ";
      }
      // If the count down is finished, write some text
      if (distance <= 0) {
        //clearInterval(_this);
        text = "Live";
      }
      return text;
    },
    getLiveShow() {
      this.$store
        .dispatch({ type: "getCurrentLiveSale" })
        .then(data => {
          this.liveShow = data.data.liveScheduleDTOs;
        })
        .catch(err => {
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },
    openLiveShow(data) {
      this.selectRoomLang = data;
      this.comments = [];
      this.socket.emit("join_channel", {
        lang: this.selectRoomLang
      });
      this.cntntLoad = true;
      this.langChannelId = data;
      this.$store
        .dispatch({
          type: "openLiveShow",
          index: this.langChannelId + "/" + 1 + "/" + "0"
        })
        .then(data => {
          this.cntntLoad = false;
          if (
            data.data &&
            data.data.liveScheduleDTOs != null &&
            data.data.liveScheduleDTOs.length > 0
          ) {
            this.liveData = data.data.liveScheduleDTOs[0];

            if (data.data.liveScheduleDTOs[0].languageCode == "hi") {
              this.salesRefId = this.liveData.id;
              this.connection.id = "mall91videochannel";
              this.isLive = true;
              bus.$emit("changeLanguage", this.connection.id);
            } else {
              this.connection.id = `mall91videochannel${this.langChannelId}`;
              this.salesRefId = this.liveData.id;
              this.isLive = true;
              bus.$emit("changeLanguage", this.connection.id);
            }
          } else {
            bus.$emit("changeLanguage", this.connection.id);
          }
        })
        .catch(err => {
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },
    getLiveProduct() {
      var _this = this;
      this.$store
        .dispatch({ type: "getLiveSale" })
        .then(data => {
          this.liveScheduleDTOs = data.data.liveScheduleDTOs;
          if (
            data.data &&
            data.data.liveScheduleDTOs != null &&
            data.data.liveScheduleDTOs.length > 0
          ) {
            this.liveData = data.data.liveScheduleDTOs[0];
            let _this = this;
            var myVideoExist = false;
            var mylang = _this.$cookie.get("lang");
            data.data.liveScheduleDTOs.findIndex(function(data) {
              if (data.languageCode === mylang) {
                _this.selectRoomLang = mylang;
                myVideoExist = true;
                _this.socket.emit("join_channel", {
                  lang: _this.selectRoomLang
                });
              }
            });
            _this.interval = setInterval(
              function(_this) {
                if (document.getElementById("timeRemaining")) {
                  document.getElementById(
                    "timeRemaining"
                  ).innerHTML = _this.setTimeText(_this.liveData, 0);
                }
              },
              1000,
              _this
            );

            if (data.data.liveScheduleDTOs.length >= 2) {
              this.nextLiveData = data.data.liveScheduleDTOs[1];
              _this.nextInterval = setInterval(
                function(_this) {
                  if (
                    document.getElementById(
                      "nextTimeRemaining_" + _this.nextLiveData.id
                    )
                  ) {
                    document.getElementById(
                      "nextTimeRemaining_" + _this.nextLiveData.id
                    ).innerHTML = _this.setTimeText(_this.nextLiveData, 1);
                  }
                },
                1000,
                _this
              );
            }

            var date = new Date();
            var startDate = new Date(Number(this.liveData.liveStartTimeMilis));
            var endDate = new Date(Number(this.liveData.liveEndTimeMilis));
            if (startDate > date) {
              setTimeout(
                function(z) {
                  z.isLive = false;
                  document.querySelector("body").classList.remove("modal-open");
                  z.salesRefId = z.liveData.id;
                  setTimeout(
                    function(a) {
                      a.isLive = false;
                      document
                        .querySelector("body")
                        .classList.remove("modal-open");
                      clearInterval(a.interval);
                    },
                    Number(z.liveData.liveEndTimeMilis) - new Date().getTime(),
                    z
                  );
                },
                Number(this.liveData.liveStartTimeMilis) - new Date().getTime(),
                this
              );
            } else if (date >= startDate && date < endDate && myVideoExist) {
              if (mylang !== "hi") {
                this.connection.id = `mall91videochannel${mylang}`;
                this.isLive = true;
              } else {
                this.isLive = true;
              }
              this.salesRefId = this.liveData.id;
              setTimeout(
                function(a) {
                  a.isLive = false;
                  clearInterval(a.interval);
                },
                Number(this.liveData.liveEndTimeMilis) - new Date().getTime(),
                this
              );
            }
          }
        })
        .catch(err => {
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    },
    more_product() {
      this.activePrdt = true;
    },
    close_product() {
      this.activePrdt = false;
    },

    likeOnLive(scheduleId) {
      if (this.liveData && this.liveData.totalLike) {
        this.liveData.totalLike = parseInt(this.liveData.totalLike) + 1;
      }

      var obj = {
        saleReferenceID: scheduleId,
        action: "LIKE",
        location: VueCookie.get("cityName")
      };

      this.$store
        .dispatch({
          type: "actionOnLiveShow",
          payload: obj
        })
        .then(
          data => {},
          response => {}
        )
        .catch(err => {
          console.log(err);
        });
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.$store
          .dispatch({ type: "getCurrentLiveSale" })
          .then(data => {
            this.availableQuantityValue =
              data.data.liveScheduleDTOs[0].itemLiveDTOs[0].availableQuantity;
            if (data.data.liveScheduleDTOs.length > this.liveShow.length) {
              this.ShowCard = true;
              this.liveShow = data.data.liveScheduleDTOs;
              this.liveScheduleDTOs = data.data.liveScheduleDTOs;
            } else if (data.data.liveScheduleDTOs.length == 0) {
              this.liveShow = [];
              this.liveScheduleDTOs = [];
              this.ShowCard = false;
            }
          })
          .catch(err => {});
      }, 10000);
    }
  },
  mounted() {
    if (this.$cookie.get("X-Auth-Id")) {
      this.nonAuthorizedUser = true;
    } else {
      this.nonAuthorizedUser = false;
    }
    this.getLiveShow();
    this.getLiveProduct();
    this.startTimer();
    var _this = this;
    if (this.$cookie.get("lang")) {
      this.selectRoomLang = this.$cookie.get("lang");
    }

    this.socket.on("connect", function() {});
    this.socket.on("user_count", function(data) {
      _this.user_count = data + "" + Math.floor(Math.random() * 100);
    });
    this.socket.on("new_messages", function(data) {
      if (data.msg == " ") {
        let obj = {
          status: "Please write comment first !",
          color: "black",
          timeoutMs: "5000"
        };
        bus.$emit("apiStatus", obj);
      } else {
        _this.comments = _this.comments.concat(data);
      }
      _this.scrollToBottom();
    });
    if (this.$cookie.get("X-Auth-Id") == null) {
      this.hidden = true;
    }

    // if (this.$store.getters.productsVideos.length > 0) {
    //   this.productsVideos = this.$store.getters.productsVideos;
    //   this.pageIndex = this.$store.getters.pageIndex;
    // } else {
    //   // this.getLiveProductsVideos();
    // }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.socket.disconnect();
  }
};
</script>